export function extractIdFromPathname(pathname: string): string {
  const matchResult = pathname?.match(/\/(product|set)\/.*-(\d+)\/?(\?.+)?$/);
  return matchResult ? matchResult[2] : '';
}
